<!-- Song Information -->
@if (currentSong(); as song) {
  <div class="song-info">
    <h3 class="song-title">{{ song.title }}</h3>
    <p class="song-artist">{{ song.artist }}</p>
  </div>
}
